import request from '../../constants/fetch';
import queryString from 'query-string';
import pickBy from 'lodash/pickBy';

/**
 * API Get request translation requests
 * @param page
 * @param size
 * @returns {Promise<unknown>}
 */
export const getRequestTranslationService = (query, options = {}) =>
    request.get(`/request-translation-service?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
* API Get request translation by id
* @param id
* @returns {Promise<unknown>}
*/
export const getRequestTranslationByIdService = (id, options = {}) =>
    request.get(`/request-translation-service/${id}`, options);
/**
 * API Download file
 * @param id
 * @returns {Promise<unknown>}
 */
export const downloadFile = (id, options = {}) =>
    request.download(`/file/download/${id}`, options);

/**
 * API Get faculties
 * @returns {Promise<unknown>}
 */
export const getFacultiesService = (options = {}) =>
    request.get(`/faculty/all`, options);

/**
 * API Get languages
 * @returns {Promise<unknown>}
 */
export const getLanguagesService = (options = {}) =>
    request.get(`/language`, options);

/**
 * API Get payment methods
 * @returns {Promise<unknown>}
 */
export const getPaymentMethodsService = (options = {}) =>
    request.get(`/payment-method`, options);

/**
 * API Get providers
 * @returns {Promise<unknown>}
 */
export const getProvidersService = (query, options = {}) =>
    request.get(`/provider?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
 * API Get customers
 * @returns {Promise<unknown>}
 */
export const getCustomersService = (query, options = {}) =>
    request.get(`/customer?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
 * API Get roles
 * @returns {Promise<unknown>}
 */
export const getRolesService = (query, options = {}) =>
    request.get(`/role?${queryString.stringify(pickBy(query, item => item !== ""), { arrayFormat: 'comma' })}`, options);

/**
 * API Edit request
 * @returns {Promise<unknown>}
 */
export const editRequestService = (data, options = {}) =>
    request.put(`/request`, data, options);

/**
 * API delete customer
 * @returns {Promise<unknown>}
 */
export const deleteCustomerService = (id) =>
    request.delete(`/customer/${id}`, {});

/**
* API delete provider
* @returns {Promise<unknown>}
*/
export const deleteProviderService = (id) =>
    request.delete(`/provider/${id}`, {});

/**
 * API Edit customer
 * @returns {Promise<unknown>}
 */
export const editCustomerService = (data, options = {}) =>
    request.put(`/customer`, data, options);

/**
* API Add customer
* @returns {Promise<unknown>}
*/
export const addCustomerService = (data) =>
    request.post(`/customer`, data);

/**
 * API Edit provider
 * @returns {Promise<unknown>}
 */
export const editProviderService = (data, options = {}) =>
    request.put(`/provider`, data, options);

/**
* API Add provider
* @returns {Promise<unknown>}
*/
export const addProviderService = (data) =>
    request.post(`/provider`, data);